import { useContext } from 'react'

import { authenticatedUserContext } from '../components/authenticated-user-provider'

export const useUser = () => {
  return useContext(authenticatedUserContext)
}
